/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const CreateAodRuleDtoReportTypeEnum = {
    AUDIT_GIP_STATUS: "AUDIT_GIP_STATUS",
    AUDIT_GIP_ALTERNATIVE_REPORT: "AUDIT_GIP_ALTERNATIVE_REPORT",
    BCR_MATCHES: "BCR_MATCHES",
    LTX_MATCHES: "LTX_MATCHES"
} as const;

export type CreateAodRuleDtoReportTypeEnumKey = (typeof CreateAodRuleDtoReportTypeEnum)[keyof typeof CreateAodRuleDtoReportTypeEnum];

export const CreateAodRuleDtoTriggerEnum = {
    ORDER_END: "ORDER_END",
    EOW_AND_ORDER_END: "EOW_AND_ORDER_END"
} as const;

export type CreateAodRuleDtoTriggerEnumKey = (typeof CreateAodRuleDtoTriggerEnum)[keyof typeof CreateAodRuleDtoTriggerEnum];

export const NotificationSettingsPolicyEnum = {
    NONE: "NONE",
    ORDER_END_ONLY: "ORDER_END_ONLY",
    ALWAYS: "ALWAYS"
} as const;

export type NotificationSettingsPolicyEnumKey = (typeof NotificationSettingsPolicyEnum)[keyof typeof NotificationSettingsPolicyEnum];

/**
 * Create AOD Rule
 * @description Schema for creating a new AOD rule
*/
export type CreateAodRuleDto = {
    /**
     * @type string, uuid
    */
    clientId: string;
    /**
     * @minLength 1
     * @maxLength 255
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    reportType: CreateAodRuleDtoReportTypeEnumKey;
    /**
     * @type object
    */
    reportConfig: {
        [key: string]: any;
    };
    /**
     * @type object
    */
    exportOptions: {
        [key: string]: any;
    };
    /**
     * @type object | undefined
    */
    exportConditions?: {
        [key: string]: any;
    };
    /**
     * @type string
    */
    trigger: CreateAodRuleDtoTriggerEnumKey;
    /**
     * @type object | undefined
    */
    notificationSettings?: {
        /**
         * @type string
        */
        policy: NotificationSettingsPolicyEnumKey;
    };
    /**
     * @type boolean | undefined
    */
    active?: boolean;
    /**
     * @type array | undefined
    */
    managers?: {
        /**
         * @type string, uuid
        */
        userId: string;
    }[];
};